// 引入特定组件及样式
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import {
    // ElAlert,
    // ElAside,
    // ElAutocomplete,
    // ElAvatar,
    ElBacktop,
    // ElBadge,
    ElBreadcrumb,
    ElBreadcrumbItem,
    ElButton,
    // ElButtonGroup,
    // ElCalendar,
    // ElCard,
    ElCarousel,
    ElCarouselItem,
    // ElCascader,
    // ElCascaderPanel,
    ElCheckbox,
    ElCheckboxButton,
    ElCheckboxGroup,
    // ElCol,
    // ElCollapse,
    // ElCollapseItem,
    // ElCollapseTransition,
    // ElColorPicker,
    // ElContainer,
    // ElDatePicker,
    ElDialog,
    ElDivider,
    // ElDrawer,
    // ElDropdown,
    // ElDropdownItem,
    // ElDropdownMenu,
    // ElFooter,
    // ElForm,
    // ElFormItem,
    // ElHeader,
    ElIcon,
    ElImage,
    ElInput,
    ElInputNumber,
    // ElLink,
    // ElMain,
    // ElMenu,
    // ElMenuItem,
    // ElMenuItemGroup,
    ElOption,
    ElOptionGroup,
    // ElPageHeader,
    ElPagination,
    // ElPopconfirm,
    // ElPopover,
    // ElPopper,
    ElProgress,
    // ElRadio,
    // ElRadioButton,
    // ElRadioGroup,
    // ElRate,
    // ElRow,
    // ElScrollbar,
    ElSelect,
    // ElSlider,
    // ElStep,
    // ElSteps,
    // ElSubmenu,
    // ElSwitch,
    // ElTabPane,
    ElTable,
    ElTableColumn,
    // ElTabs,
    ElTag,
    // ElTimePicker,
    // ElTimeSelect,
    // ElTimeline,
    // ElTimelineItem,
    ElTooltip,
    // ElTransfer,
    // ElTree,
    // ElUpload
    
} from 'element-plus'

//注册特定组件
const components = [
    // ElAlert,
    // ElAside,
    // ElAutocomplete,
    // ElAvatar,
    ElBacktop,
    // ElBadge,
    ElBreadcrumb,
    ElBreadcrumbItem,
    ElButton,
    // ElButtonGroup,
    // ElCalendar,
    // ElCard,
    ElCarousel,
    ElCarouselItem,
    // ElCascader,
    // ElCascaderPanel,
    ElCheckbox,
    ElCheckboxButton,
    ElCheckboxGroup,
    // ElCol,
    // ElCollapse,
    // ElCollapseItem,
    // ElCollapseTransition,
    // ElColorPicker,
    // ElContainer,
    // ElDatePicker,
    ElDialog,
    ElDivider,
    // ElDrawer,
    // ElDropdown,
    // ElDropdownItem,
    // ElDropdownMenu,
    // ElFooter,
    // ElForm,
    // ElFormItem,
    // ElHeader,
    ElIcon,
    ElImage,
    ElInput,
    ElInputNumber,
    // ElLink,
    // ElMain,
    // ElMenu,
    // ElMenuItem,
    // ElMenuItemGroup,
    ElOption,
    ElOptionGroup,
    // ElPageHeader,
    ElPagination,
    // ElPopconfirm,
    // ElPopover,
    // ElPopper,
    ElProgress,
    // ElRadio,
    // ElRadioButton,
    // ElRadioGroup,
    // ElRate,
    // ElRow,
    // ElScrollbar,
    ElSelect,
    // ElSlider,
    // ElStep,
    // ElSteps,
    // ElSwitch,
    // ElTabPane,
    ElTable,
    ElTableColumn,
    // ElTabs,
    ElTag,
    // ElTimePicker,
    // ElTimeSelect,
    // ElTimeline,
    // ElTimelineItem,
    ElTooltip,
    // ElTransfer,
    // ElTree,
    // ElUpload,
]

export default (app) => {
    components.forEach(component => {
        app.component(component.name, component)
    })
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        app.component(key, component)
      }
}